export default [
  {
    facultyImage: "https://i.ibb.co/MPGk7QZ/241115-17h30m45s-screenshot.png",
    faculty: "Dr. Rajendra R. Sawant",
    position: "Co-Founder",
    company: "Inventronics Pvt Ltd",
    logoImage: "https://i.ibb.co/tJxWXW9/rrs.png",
    link: "https://www.inventronics.co.in/",
    shortlink: "inventronics.co.in"
  },
  {
    facultyImage: "https://i.ibb.co/K2R43hV/241115-17h30m19s-screenshot.png",
    faculty: "Dr. Y.S. Rao",
    position: "Director",
    company: "Go-Green Technologies Pvt. Ltd",
    logoImage: "https://i.ibb.co/kKK5NLY/ysr2.png",
    link: "https://yrkmgstc.in",
    shortlink: "yrkmgstc.in",
  },
] 
